import React from 'react';
import {
    shape,
    arrayOf,
    func,
    string,
    bool,
    object,
    number,
    oneOfType
} from 'prop-types';
// import Icon from 'components/icon';
import KeywordFilter from './keyword-filter/';
import MultiCheckboxFilter from './multi-checkbox-filter/';
import SingleCheckboxFilter from './single-checkbox-filter/';
import TagFilter from './tag-filter/';
import * as FilterTypeConstants from '../constants/filter-types';
import { getActiveValues } from '../utils/active-filters';

export default function FiltersSection({
    filters,
    filterSettings,
    activeFilters,
    toggleFilters,
    resetFilterGroup,
    focusedFilter,
    toggleFocus,
    menuActive,
    filteredItems,
    contentData,
    filterCount,
    fadeOpacity,
    isProductFinder
    // resetFilters,
    // handleToggleMenu,
    // noItemsText
}) {
    return (
        <div className={`filters-section ${menuActive ? 'is-active' : ''}`}>
            <div className="filters-container">
                {/* ADD TO LOCALIZATION */}
                <h4 className="filters-title">Filters</h4>
                {/* ADD TO LOCALIZATION */}
                <div
                    className={`filters ${
                        isProductFinder ? 'filters--finder' : ''
                    }`}
                >
                    {/* No need for this in the current version */}
                    {/* <button
                        id="active-filter-reset"
                        className={`active-filter-reset ${
                            activeFilters.length ? 'has-some-filters' : ''
                        }`}
                        onClick={resetFilters}
                        onKeyPress={resetFilters}
                    >
                        <small className="btn-text">{noItemsText}</small>
                        <Icon glyph="cross" />
                    </button> */}
                    {filters.map(filter => {
                        const activeValues = getActiveValues(
                            filter,
                            activeFilters
                        );
                        const availableItems =
                            activeValues.length &&
                            filter.queryOperator !== 'and'
                                ? contentData
                                : filteredItems;

                        switch (true) {
                            case filter.type ===
                                FilterTypeConstants.FILTER_TYPE_KEYWORDS &&
                                !isProductFinder:
                                return (
                                    <KeywordFilter
                                        key={filter.code}
                                        filter={filter}
                                        keyword={
                                            activeValues.length
                                                ? activeValues[0]
                                                : ''
                                        }
                                        updateKeyword={toggleFilters}
                                        placeholderText={
                                            filterSettings.keywordPlaceholderText
                                                ? filterSettings.keywordPlaceholderText
                                                : 'Enter keywords'
                                        }
                                        classModifier="filter-item"
                                    />
                                );

                            case filter.type ===
                                FilterTypeConstants.FILTER_TYPE_MULTI_CHECKBOX:
                                return (
                                    <MultiCheckboxFilter
                                        key={filter.code}
                                        filter={filter}
                                        selectedItems={activeValues}
                                        toggleFilters={toggleFilters}
                                        classModifier={`filter-item ${
                                            filter.parent
                                                ? 'parent-category'
                                                : ''
                                        }`}
                                        isFocused={
                                            focusedFilter === filter.code
                                        }
                                        toggleFocus={toggleFocus}
                                        resetFilterGroup={resetFilterGroup}
                                        activeFilters={activeFilters}
                                        availableItems={availableItems}
                                        keywordSearchableFields={
                                            filterSettings.keywordSearchableFields
                                        }
                                        excludedSearchAttr={
                                            filterSettings.excludedSearchAttr
                                        }
                                        filterCount={filterCount}
                                        fadeOpacity={fadeOpacity}
                                        filteredItemsLength={
                                            filteredItems.length
                                        }
                                    />
                                );

                            case filter.type ===
                                FilterTypeConstants.FILTER_TYPE_SINGLE_CHECKBOX:
                                return (
                                    <SingleCheckboxFilter
                                        key={filter.code}
                                        filter={filter}
                                        isChecked={
                                            activeValues.length
                                                ? filter.values[0] ===
                                                  activeValues[0]
                                                : false
                                        }
                                        toggleFilters={toggleFilters}
                                        classModifier="filter-item"
                                    />
                                );

                            case filter.type ===
                                FilterTypeConstants.FILTER_TYPE_TAGS:
                                return (
                                    <TagFilter
                                        key={filter.code}
                                        filter={filter}
                                        selectedItems={activeValues}
                                        toggleFilters={toggleFilters}
                                        resetFilterGroup={resetFilterGroup}
                                        classModifier="filter-item"
                                        isFocused={focusedFilter === filter}
                                        toggleFocus={toggleFocus}
                                    />
                                );

                            default:
                                return null;
                        }
                    })}
                    {/* No need for this in the current version */}
                    {/* <button
                        className="apply-filters"
                        onClick={handleToggleMenu}
                    >
                        Apply changes
                    </button> */}
                </div>
            </div>
        </div>
    );
}

FiltersSection.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    filters: arrayOf(
        shape({
            code: string.isRequired,
            label: string.isRequired,
            values: arrayOf(oneOfType([string, bool, number]))
        })
    ).isRequired,
    filterSettings: shape({
        itemsPerPage: number,
        showResultCount: bool,
        showActiveFilters: bool,
        activeFiltersStyle: string,
        activeFiltersLabel: string,
        keywordPlaceholderText: string,
        keywordSearchableFields: arrayOf(string),
        sortBy: arrayOf(object)
    }).isRequired,
    activeFilters: arrayOf(
        shape({
            code: string.isRequired,
            label: string.isRequired,
            values: arrayOf(oneOfType([string, bool, number])).isRequired
        })
    ).isRequired,
    focusedFilter: string,
    toggleFilters: func.isRequired,
    resetFilterGroup: func.isRequired,
    toggleFocus: func.isRequired,
    menuActive: bool.isRequired,
    filteredItems: arrayOf(object).isRequired,
    contentData: arrayOf(object).isRequired,
    filterCount: bool.isRequired,
    fadeOpacity: string.isRequired,
    isProductFinder: bool.isRequired
    // noItemsText: string.isRequired,
    // handleToggleMenu: func.isRequired,
    // resetFilters: func.isRequired,
    /* eslint-enable react/no-typos */
};

FiltersSection.defaultProps = { focusedFilter: null };
